import {
  ACCESS_TOKEN_NAME,
  JSON_CONTENT_TYPE,
} from '../../_constant/constants';
import { ReestrPaymentDto } from '../../_dto/_reestr/ReestrPaymentDto';
import { IApiParams } from '../../_interface/IApiParams';
import { getApi } from '../getApi';

export const apiPaymentReestrDoc = async (dto: ReestrPaymentDto) => {
  const params: IApiParams = {
    url: '/reestr/createPaymentDoc.php',
    headers: {
      'Content-Type': JSON_CONTENT_TYPE,
      'Access-Token': localStorage.getItem(ACCESS_TOKEN_NAME),
    },
  };
  return getApi(params, 'POST', dto);
};
